import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutWebCrm } from '../../features/auth/newAuth'
import { getSubdivisonsInfo, getallSubdivisions } from '../../features/implementers/ImplemetnersSlice'
import { getDepartmentIcon } from '../../global/utils/iconsUtils'
import { createNotify } from '../../global/utils/utils'
import Loading from '../loading/Loading'
import ChoiceHeader from './ChoiceHeader'
import './ChoiseSubdivisions.css'
import ColumnSubdivision from './ColumnSubdivision'

const ChoiceSubdivisions = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { allSubdivisionsList, allSubdivisionsUUIDs, icons, iconsLoading } = useSelector(state => state.implementers)
    const { isLoading, } = useSelector(state => state.ui)
    const [choicesList, setChoicesList] = useState([])

    const prevChoice = JSON.parse(localStorage.getItem('previous_choice'))

    const changingList = (uuid) => {
        if (choicesList.includes(uuid)) setChoicesList(choicesList.filter(id => uuid !== id))
        else setChoicesList([...choicesList, uuid])
    }


    const reset = () => setChoicesList([])
    const choiceAll = () => setChoicesList(allSubdivisionsUUIDs)
    const showData = () => {
        if (choicesList?.length) dispatch(getSubdivisonsInfo({ list_uuids: choicesList, navigate }))
        else createNotify('Пожалуйста, выберите подразделение')
    }
    const logOut = () => {
        dispatch(logoutWebCrm({ navigate }))
    }

    const getGroupByID = (id) => allSubdivisionsList.find((group) => group.id === id)

    const choiceGroupByID = (id) => {
        const group = getGroupByID(id)
        if (!group) return

        const groupChoiced = group.list.reduce((acc, sub) => [...acc, sub.subdivision_uuid], [])
        setChoicesList(Array.from(new Set([...choicesList, ...groupChoiced])))
    }
    const cancleGroupByID = (id) => {
        const group = getGroupByID(id)
        if (!group) return

        const groupCancled = group.list.reduce((acc, sub) => [...acc, sub.subdivision_uuid], [])
        const removedGroup = choicesList.filter((uuid) => !groupCancled.includes(uuid))
        setChoicesList(removedGroup)
    }

    useEffect(() => {
        localStorage.setItem('previous_choice', JSON.stringify(choicesList))
    }, [choicesList])

    useEffect(() => {
        if (!allSubdivisionsList.length) dispatch(getallSubdivisions())
        if (prevChoice) setChoicesList(prevChoice)
    }, [])

    if (isLoading || iconsLoading) return <Loading />

    // Всегда 3 колонки, элементы распределяются циклически
    const columnsPerRow = 3;

    // Распределяем группы циклически по колонкам
    const columnsData = Array.from({ length: columnsPerRow }, () => []);
    allSubdivisionsList.forEach((subdivision, index) => {
        columnsData[index % columnsPerRow].push(subdivision);
    });

    const getIconByUUID = (uuid) => {
        return getDepartmentIcon(uuid, icons)
    }

    const renderColumn = (subdivisionsList) => subdivisionsList.map((subdivisions) => {
        const icon = getIconByUUID(subdivisions.group_uuid)
        return (
            <ColumnSubdivision
                key={subdivisions.group_uuid}
                choicesList={choicesList}
                subdivisions={subdivisions}
                changingList={changingList}
                choiceGroupByID={choiceGroupByID}
                cancleGroupByID={cancleGroupByID}
                icon={icon}
            />
        )
    })

    return (<>
        <div className='choice_subdivisions'>
            <ChoiceHeader reset={reset} choiceAll={choiceAll} showData={showData} logOut={logOut} />

            <div className="subdivisions_choice_list">
                {columnsData.map((columnSubdivisions, index) => (
                    <div key={index} className="subdivisions_choice_column">
                        {renderColumn(columnSubdivisions)}
                    </div>
                ))}
            </div>

        </div>
    </>

    )
}

export default ChoiceSubdivisions
